var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-button',{staticClass:"back_style",attrs:{"type":"primary"},on:{"click":_vm.goNext}},[_vm._v(" "+_vm._s(_vm.$t('common.back')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }